import React, { useEffect, useState } from "react";
import styles from "./AvatarLogin.module.css";
import { useNavigate } from "react-router-dom";
import { sendDataToApi } from "../../api/Api";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
} from "mdb-react-ui-kit";

const AvatarLogin = () => {
  const navigate = useNavigate();
  const [uniqueId, setUniqueId] = useState();
  const [centredModal, setCentredModal] = useState(false);
  const [state, setState] = useState(true)

  const Sdk = () => {
    useEffect(() => {
      if(state) {
        fetch(
          "https://sdk.work.stream/sdk?id=did:avtr:55tKBhYNb9HSMpqvhBDiog&businessEmail=ss@sbmurban.org"
        )
          .then((response) => response.text())
          .then((data) => {
            const script = document.createElement("script");
            script.textContent = data;
            document.head.appendChild(script);
            window.avatarSdk &&
              window.avatarSdk.onQRVerificarion().then((response) => {
                // console.log(response,"RES")
                setUniqueId(response);
                setState(false)
              });
          });
      }
    }, []);
    return (
      <div className='App'>
        <div id='avatar-qr'></div>
      </div>
    );
  };
  
  let uniqueIdNumber = uniqueId?.email?.substring(0, 6);
  const toggleShow = () => setCentredModal(!centredModal);

  const closeButton = () => {
    setCentredModal(!centredModal);
    navigate("/");
  };

  const sendUniqueId = () => {
    sendDataToApi(`avatarIdExists/${uniqueIdNumber}`).then((res) => {
      if (res.data === false) {
        localStorage.setItem("login", true);
        navigate("/selectlanguage", { state: { uniqueIdNumber } });
      } else if (res.data === true) {
        toggleShow();
      }
    });
  };

  useEffect(() => {
    if (uniqueIdNumber) {
      sendUniqueId();
    }
  }, [uniqueIdNumber]);

  return (
    <>
      <div className='container'>
        <div className={styles.mainWrapper}>
          <p className={styles.headingText}>LOGIN</p>
          <p className={styles.subHeadingText}>
            Use Free Passwordless Authentication
          </p>
          <div className={styles.avatarDescWrapper}>
            <p>
              The Avatar App gives you free access to a secure and private
              passwordless authentication system. You can use the Avatar app to
              login without a password on any compatible service. To learn more,
              visit <a href='https://avatar.me/#/in'>https://avatar.me/#/in</a>
            </p>
          </div>
          <p className={styles.qrCodeTitle}>
            Open the Avatar App and scan this code
          </p>
          <div className={styles.sdkWrapper}>
            <Sdk />
          </div>
          <div className={styles.downloadAppText}>
            <p>
              Don’t have the Avatar App? <br />
              Get it for free
            </p>
          </div>
          <div className={styles.downloadButtonWrapper}>
            <a 
            href='https://apps.apple.com/us/app/avatar-identity/id1601362763' 
            target='_blank' 
            rel='noopener noreferrer'>
              <button className={styles.downloadButton}>iOS</button>
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=me.avatar.app&pli=1'
              target='_blank'
              rel='noopener noreferrer'
            >
              <button className={styles.downloadButton}>Android</button>
            </a>
          </div>
        </div>
      </div>
      <MDBModal tabIndex='-1' show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog className={styles.modalDialog} centered>
          <MDBModalContent className={styles.popupContent}>
            <MDBModalBody>
              <div className={styles.popupMainWrapper}>
                <div className={styles.popupHeaderWrapper}>
                  <p className={styles.popupHeader}>Duplicate Response</p>
                </div>
                <div className={styles.popupbodyWrapper}>
                  <p className={styles.popupbody}>
                    You can only take this survey once. Your survey responses
                    have already been recorded. Thank you for your
                    participation.
                  </p>
                </div>
                <div>
                  <button
                    className={styles.popupCloseButton}
                    onClick={closeButton}
                  >
                    Close
                  </button>
                </div>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
};

export default AvatarLogin;
